import AdminApi from '../../../services/api'
import swal from 'sweetalert2';
import session from "../../../services/session";

const AdminApiService = new AdminApi()

export default {
    data() {
        return {
            model: {
                email: '',
                name: '',
                phone: '',
                surname: '',
                role: 'ROLE_USER',
                username: '',
                paidDate: null,
                expireDate: null,
                restOfTraining: 0
            }
        }
    },
    methods: {
        register : register,
        clear : clear
    },
    beforeMount() {
        if(session.getRole() !== 'ADMIN' && session.getRole() !== 'DISPATCHER') {
            this.$router.push('/home');
            return;
        }
    }
}

function clear() {
    this.model.email = '';
    this.model.name = '';
    this.model.phone = '';
    this.model.surname = '';
    this.model.role = 'ROLE_USER';
    this.model.username = '';
    this.model.paidDate = null;
    this.model.expireDate = null;
    this.model.restOfTraining = 0;
}

function register() {
    // this.model.paidDate =this.model.paidDate + 'T00:00:00.000Z';
    // this.model.expireDate =this.model.expireDate + 'T00:00:00.000Z';
    AdminApiService.registerUser(this.model)
        .then((response) => {
           swal('Success','Korisnik dodat','success')
           this.clear()
        })
        .catch(error => {
            swal('Greška', error.data.localized_error_message, 'error')
        })
}


// WEBPACK FOOTER //
// ./src/components/Users/Add/AddUser.js